require('./impromptu');

jQuery(function() {
    var specialGiftPromptHtml =
        '<div class="special-action">' +
        '<img class="special-action__bg-img" src="local/assets/img/bg-product-gift.jpg" alt="Спецпредложение" />' +
        '<div class="special-action__content">' +
        '<div class="special-action__title">Спецпредложение</div>' +
        '<div class="special-action__box">' +
        'Купите это чудесное масло сегодня и получите подарок, точно такое же масло, но с просроченным сроком годности!' +
        '</div>' +
        '<a href="#" class="special-action__btn btn-def btn-def--pink">Абсолютно <span class="special-action__btn-b">бесплатно!</span></a>' +
        '</div>' +
        '</div>';

    //какое-нибудь условие для показа рекламного всплывающего блока
    if (window.location.href.indexOf('product2.html') != -1) {
        setTimeout(function() {
            $.prompt(specialGiftPromptHtml, {
                buttons: {},
                persistent: false, //чтобы можно было закрыть при клике по оверлею
                classes: {
                    prompt: 'prompt--large',
                    form: 'prompt__form-special',
                    close: 'jqiclose--cross'
                }
            });
        }, 1000);
    }
});



// WEBPACK FOOTER //
// ./blocks/impromptu/impromptu-product-gift.js